<template>
    <b-modal
            :visible="showModal === 'cancelOrder'"
            @hidden="hideCancelModal"
            :lazy="true"
            >
        <div slot="modal-title">
            <h4 v-if="order" class="modal-title">Отменить заказ № {{order.id}}</h4>
        </div>
        <loading v-if="loading" :size="3" message="Заказ отменяется..."></loading>
        <form v-else сlass="form-horizontal" @submit.prevent="cancel">
            <div class="form-group" :class="{ 'has-danger': $v.text.$error }">
                <label class="form-control-label" for="cancel-input">Причина отмены заказа</label>
                <textarea ref="focusThis" id="cancel-input"  rows="4" v-model="text" @input="$v.text.$touch()" class="form-control" placeholder="Укажите по какой причине заказ отменяется?"></textarea>
                <span class="small help-block text-danger" v-if="$v.text.$error">Для отмены заказа необходимо обязательно указать причину</span>
            </div>
        </form>
        <div slot="modal-footer" >
            <b-btn v-if="!loading" @click.prevent="hideCancelModal">Не отменять</b-btn>
            <b-btn v-if="!loading" variant="danger" :class="{ 'disabled': $v.text.$invalid }" :disabled="$v.text.$invalid" @click.prevent="cancel">Отменить заказ</b-btn>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength } from 'vuelidate/lib/validators'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: mapState({
      showModal: state => state.orderStore.showModal,
      order: state => state.orderStore.editOrder
    }),
    data () {
      return {
        text: '',
        loading: false
      }
    },
    methods: {
      cancel () {
        this.loading = true
        this.$store.dispatch('cancelOrder', {
          cause: this.text,
          value: true,
          orderId: this.order.id
        }).then((data) => {
          this.loading = false
          this.text = ''
          this.$store.commit('SET_SHOW_ORDER_MODAL', null)
          this.addToast({
            text: 'Заказ отменен',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при отмене заказа:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
        })
      },
      hideCancelModal (e) {
        this.$store.dispatch('setEditOrder', null)
        this.$store.commit('SET_SHOW_ORDER_MODAL', null)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    validations: {
      text: {
        required,
        minLength: minLength(5)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalCancelOrder.vue?39745398